module.exports = __webpack_public_path__ + "img/microsoft.98a41061.jpg";